import { defaultTheme } from 'react-select'

// react-select берёт цвета из defaultTheme, если в компонент не передан свой theme
// (а передают его в одном месте из ~200). Меняем цвета один раз на всё приложение:
// значения — css-переменные с исходным цветом по умолчанию, поэтому светлая тема
// не меняется, а тёмная подхватывается без перерисовки (см. assets/css/theme.css).
// Цвета react-select только подставляет в css, вычислений над ними нет.
const colors = defaultTheme.colors

Object.assign(colors, {
	primary25: `var(--dark-tint-primary, ${colors.primary25})`,
	primary50: `var(--dark-tint-border-primary, ${colors.primary50})`,
	neutral0: `var(--dark-surface, ${colors.neutral0})`,
	neutral5: `var(--dark-surface-2, ${colors.neutral5})`,
	neutral10: `var(--dark-surface-4, ${colors.neutral10})`,
	neutral20: `var(--dark-border-strong, ${colors.neutral20})`,
	neutral30: `var(--dark-border-strong, ${colors.neutral30})`,
	neutral40: `var(--dark-text-muted, ${colors.neutral40})`,
	neutral50: `var(--dark-text-muted, ${colors.neutral50})`,
	neutral60: `var(--dark-text-muted, ${colors.neutral60})`,
	neutral70: `var(--dark-text, ${colors.neutral70})`,
	neutral80: `var(--dark-text-strong, ${colors.neutral80})`,
	neutral90: `var(--dark-text-strong, ${colors.neutral90})`,
	dangerLight: `var(--dark-tint-danger, ${colors.dangerLight})`,
})
